import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// import Button from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
// import DialogActions from '@mui/material/DialogActions';

const dialogRoot_ = (theme) => ({
  pointerEvents: "none",
  "& .MuiBackdrop-root": {
    backgroundColor: "transparent",
  },
  "& .MuiDialog-container": {
    justifyContent: "flex-start",
    alignItems: "flex-end",
  },
});

const closeIconBtn_ = (theme) => ({
  position: "absolute !important",
  top: 0,
  right: 0,
  [theme.breakpoints.down("sm")]: {
    top: 5,
    right: 5,
    "& .MuiSvgIcon-root": {
      fontSize: "1.7rem",
    },
  },
});

const paper_ = (theme) => ({
  pointerEvents: "auto",
  margin: "0px",
  maxHeight: "100vh",
  width: "45vw",
  minWidth: 335,
  maxWidth: 600,
  [theme.breakpoints.down("lg")]: {
    width: "80vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "90vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "95vw",
  },
  "& .MuiDialogContent-root": {
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "2px",
    },
  },
});

export default function Menu({
  children,
  visible,
  selectHandler,
  onCloseHandler,
  menuType,
  offset,
}) {
  const descriptionElementRef = useRef(null);

  const [open, setOpen] = useState(visible);
  const handleClose = () => {
    setOpen(false);
    if (onCloseHandler) {
      onCloseHandler(menuType || "");
    }
  };

  const [heightOffset, setHeightOffset] = useState((offset || 0) + "px");
  useEffect(() => {
    setHeightOffset((offset || 0) + "px");
  }, [offset]);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        // disableBackdropClick={true}
        sx={dialogRoot_}
        slotProps={{
          paper: {
            style: {
              height: `calc(100% - ${heightOffset})`,
            },
            sx: paper_,
          },
        }}
      >
        <DialogContent dividers={true}>
          {React.cloneElement(children, { open, selectHandler })}
          <IconButton
            aria-label="Close"
            sx={closeIconBtn_}
            onClick={handleClose}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </DialogContent>
        {/* <DialogActions sx={btnContainer_}>
          <Button variant="contained" onClick={handleClose} color="secondary">
            Close
          </Button>
          <Button variant="contained" onClick={handleClose} color="primary">
            Search
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}
